<!--
 * @Author: W9013327 v-maijiahua@oppo.com
 * @Date: 2023-02-17 16:16:30
 * @LastEditors: jordan.lu jordan.lu@oppo.com
 * @LastEditTime: 2024-01-24 11:21:55
 * @FilePath: \sns-user-frontend\src\components\wap\wapDialog.vue
 * @Description: 
-->
<template>
  <van-dialog 
    v-model:show="visible" 
    :close-on-click-overlay="true" 
    :class="position ? `custom-position ${className}` : className"
    :overlayStyle="!layer ? {
      background: 'transparent'
    } : {}"
    :showConfirmButton="false"
    :teleport="teleport"
    :z-index="zIndex"
    @click.prevent.stop
  >
    <!-- 标题 -->
    <template #title>
      <slot name="title">
        <p class="title" v-if="title">{{ title }}</p>
      </slot>
    </template>
    <!-- 内容 -->
    <slot>
      <p class="content" :class="!title && 'mt'">{{ content }}</p>
    </slot>
    <!-- 底部 -->
    <template #footer v-if="needFoot">
      <template v-if="showCancel">
        <slot name="cancel">
          <p class="dialog-footer" :style="{
            color: buttonColor || 'var(--theme)'
          }" @click="onCancel">{{ cancelText || $t('cancel') }}</p>
        </slot> 
      </template>
      <template v-if="showConfirm">
        <slot name="confirm">
          <div class="button-group">
            <span @click="onCancel">{{ cancelText || $t('cancel') }}</span>
            <span @click="onConfirm">{{ confirmText || $t('yes') }}</span>
          </div>
        </slot> 
      </template>
    </template>
  </van-dialog>
</template>

<script setup>
import { watchEffect, ref, nextTick, watch } from 'vue';

const emit = defineEmits(['update:show'])
const props = defineProps({
  show: {
    type: Boolean,
    default: false
  },
  teleport: {
    type: String,
    default: ''
  },
  content: {
    type: String,
    default: ''
  },
  bottom: {
    type: Boolean,
    default: false
  },
  needFoot: {
    type: Boolean,
    default: true
  },
  title: {
    type: String,
    default: ''
  },
  layer: {
    type: Boolean,
    default: true
  },
  position: {
    type: Object
  },
  showCancel: {
    type: Boolean,
    default: false
  },
  showConfirm: {
    type: Boolean,
    default: true
  },
  cancelCallBack: {
    type: Function
  },
  confirmCallBack: {
    type: Function
  },
  confirmText: {
    type: String,
    default: ''
  },
  cancelText: {
    type: String,
    default: ''
  },
  className: {
    type: String,
    default: ''
  },
  zIndex: {
    type: String,
  },
  buttonColor: {
    type: String,
  }
})

const visible = ref(false)
const className = ref('')

const onCancel = () => {
  if (props.cancelCallBack) {
    props.cancelCallBack()
  } else {
    visible.value = false
  }
}
const onConfirm = () => {
  if (props.confirmCallBack) {
    props.confirmCallBack()
  } else {
    visible.value = false
  }
}

watchEffect(() => {
  visible.value = props.show
  if (props.bottom) {
    className.value = 'dialog-align-bottom'
  }
})

watchEffect(() => {
  emit('update:show', visible.value)
})

watch(() => props.position, (val) => {
  if (val && Object.keys(val).length) {
    className.value = props.className
    setTimeout(() => {
      let { left, top } = val
      const {clientWidth, clientHeight} = document.documentElement
      const {offsetWidth, offsetHeight} = document.querySelector(`.${className.value}`)
      if (clientWidth - left <= offsetWidth) {
        left = clientWidth - offsetWidth - 20
      }
      if (clientHeight - top <= offsetHeight) {
        top = clientHeight - offsetHeight - 20
      }
      document.querySelector(`.${className.value}`).style.left = `${left}px`
      document.querySelector(`.${className.value}`).style.top = `${top}px`
    }, 100)
  } 
}, {
  immediate: true,
  deep: true
})

</script>

<style lang="postcss" scoped>
.dialog-footer {
  display: flex;
  align-items: center;
  justify-content: center;
  width: calc(100% - 48px);
  margin: 0 auto;
  height: 68px;
  /* box-shadow: 0 -0.68px 0 0 var(--line); */
  box-sizing: border-box;
  color: var(--theme);
}
.title {
  color: var(--text-primary);
  font-weight: normal;
  font-family: 'orbit-M';
  font-size: 18px;
  padding: 24px 0 12px;
}
.content {
  padding: 0 20px 4px;
  font-size: 14px;
  text-align: center;
}
.mt {
  margin-top: 24px;
}
.button-group {
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: space-between;
  height: 56px;
  span {
    position: relative;
    width: 50%;
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    color: var(--theme);
    &:first-child::after {
      content: "";
      position: absolute;
      right: 0;
      width: .66px;
      height: 22px;
      background: var(--line);
    }
  }
}

</style>
<style lang="postcss">
.van-dialog {
  --van-dialog-header-padding-top: 0;
  --van-dialog-background: var(--background-selection);
  box-shadow: 0 5px 12px rgb(0 0 0 / 8%);
}
.dialog-align-bottom {
  top: unset;
  bottom: 20px;
  transform: unset;
  width: calc(100vw - 40px);
}
.custom-position {
  --van-dialog-radius: 8px;
  width: fit-content;
  margin: 0;
}
</style>